module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue.108a5c8b87be7ae364de8ab759efff2d.png";